import React, { useState } from 'react'
import { mediaInfo } from '../../Elements/UI/fileLink'

function UpdatesCard({ item }) {
    const title = item?.Data?.Title || item?.title || 'Update'
    const { url, isVideo } = mediaInfo(item)
    const [videoFailed, setVideoFailed] = useState(false)

    return (
        <>
            {url && isVideo && !videoFailed && (
                <video
                    className="bl-feed-card__media bl-feed-card__video"
                    // #t=0.1 makes browsers paint the first frame as a preview
                    src={url.includes('#') ? url : `${url}#t=0.1`}
                    controls
                    preload="metadata"
                    playsInline
                    aria-label={title}
                    onError={() => setVideoFailed(true)}
                >
                    <a href={url} target="_blank" rel="noopener noreferrer">Download video</a>
                </video>
            )}
            {url && isVideo && videoFailed && (
                <div className="bl-video-fallback" role="note">
                    <ion-icon name="videocam-off-outline" aria-hidden="true"></ion-icon>
                    <div>
                        <strong>This video can’t be played here</strong>
                        <span>The file format isn’t supported by this browser.</span>
                    </div>
                    <a
                        href={url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-secondary btn-sm"
                        aria-label={`Open video: ${title} (opens in a new tab)`}
                    >
                        <ion-icon name="open-outline" aria-hidden="true"></ion-icon>
                        Open video
                    </a>
                </div>
            )}
            {url && !isVideo && (
                <a
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bl-feed-card__media-link"
                    aria-label={`Open image: ${title} (opens in a new tab)`}
                >
                    <img
                        src={url}
                        alt={title}
                        className="bl-feed-card__media"
                        loading="lazy"
                        decoding="async"
                    />
                </a>
            )}
            <p className="bl-feed-card__title">{title}</p>
        </>
    )
}

export default UpdatesCard
